import React, { FC } from 'react';
import { ProductModel } from '../../shared/orders';
import { useTranslation } from '../translations';
import { getProductPrice } from '../utils/product';

interface PriceBreakdownProps {
  readonly product: ProductModel;
}

export const PriceBreakdown: FC<PriceBreakdownProps> = ({ product }: PriceBreakdownProps) => {
  const { ts } = useTranslation();
  const { price } = getProductPrice(product);

  if (product.price === 0) {
    return <span className="text-success">{ts('free')}</span>;
  }

  return <span>{price}</span>;
};
